module.exports = __webpack_public_path__ + "static/media/01.2e53c47c.jpg";